import { emailValidationRegex, beneficiaryNameRegex, phoneNumberValidationRegex } from "../app_methods";
import { get, post, put, patch   } from "../services/HttpService";


export class User {
    constructor(userObject = {}) {
        this.set(userObject);
    };

    static validations = {
        "id": [],
        "created_at": [],
        "name": [
            { required: true, message: "Name is required." },
            { pattern: beneficiaryNameRegex(), message: "Please enter a valid Name." },
            { max: 50, message: "Can be of maximum 50 characters" }
        ],
        "password": [
            { required: true, message: "Password is required." }
        ],
        "email": [
            { required: true, message: "Email ID is required." },
            { pattern: emailValidationRegex(), message: "Please enter a valid Email ID." }
        ],
        "phone": [
            { required: true, message: "Phone is required." },
            { pattern: phoneNumberValidationRegex(), message: "Phone Number is invalid." }
        ],
    };

    /**
     * @memberof User
     * @type API
     * @returns Promise
     */
    static list = (queryData = {}, config = {}) => {
        return get(`v1/internal/users/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }));
    };

    static permission_list = (queryData = {}, config = {}) => {
        return get(`v1/internal/users/permissions/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }));
    };

    /**
     * @memberof User
     * @type API
     * @returns Promise
     */
    save = () => {
        let queryData = this.get();
        if (queryData.id) return put(`v1/internal/users/${this.id}/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
        return post(`v1/internal/users/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    setPermission = () => {
        let queryData = this.get();
        return put(`v1/internal/users/${this.id}/permissions/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

  
    /**
     * @memberof User
     * @type API
     * @returns Promise
     */
    send_password = () => {
        return post(`v1/internal/users/${this.id}/send_password/`, {}, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    update_status = (queryData) => {
        return patch(`v1/internal/users/${this.id}/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    }
    
    /**
     * @memberof User
     * @type API
     * @returns Promise
     */
    change_password = (queryData) => {
        return post(`v1/internal/users/${this.id}/password/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    /**
     * @memberof User
     * @type Getter Method
     * @takes void
     * @returns User Params
     */
    get = () => {
        return {
            id: this.id,
            name: this.name,
            email: this.email,
            phone: this.phone,
            is_admin: this.is_admin,
            permissions: this.permissions,
            level: this.level,
            role:this.role
        }
    };

    /**
     * @memberof User
     * @type Setter Method
     * @takes User Params
     * @returns void
     */
    set = (values) => {
        Object.keys(values).forEach(x => this[x] = values[x]);
    };

    /**
     * @memberof User
     * @type Setter Method
     * @takes User Params
     * @returns void
     */
    reset = () => {
        this.id = null;
        this.name = null;
        this.email = null;
        this.phone = null;
        this.is_admin = null;
        this.permissions = [];
        this.level = null;
        this.role = null;
    };
}